import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import { translate } from "react-switch-lang";

function SubCategoryCard({
  t,
  subCatValue = [],
  onCardChange,
  subCatData = [],
}) {
  const [open, setOpen] = useState(false);
  


  const toggleItem = (item) => {
    const isSelected = subCatValue.includes(item);
    
    const updated = isSelected
      ? subCatValue.filter((i) => i !== item)
      : [...subCatValue, item];
    
    onCardChange(updated);
    // Close the dropdown after selection
    setOpen(false);
  };

  const renderTitle = () => {
    if (subCatValue.length === 0) return `📋 ${t("subCategories.Placeholder")}`;
    if (subCatValue.length === 1) return `📋 ${subCatValue[0]}`;
    return `📋 已選 ${subCatValue.length}`;
  };

  return (
    <Dropdown
      drop="down"
      show={open}
      onToggle={(isOpen) => setOpen(isOpen)}
      className="filter-pill w-100"
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-toggle-pill w-100 text-start"
      >
        {renderTitle()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Array.isArray(subCatData) ? subCatData.map((item, idx) => {
          const label =
            typeof item === "string"
              ? item
              : t("subCategories.Title") in item
              ? item[t("subCategories.Title")]
              : item.label;


          return (
            <Dropdown.Item
              key={idx}
              as="button"
              className="d-flex align-items-center"
              onClick={() => {
                toggleItem(label);
              }}
            >
              <input
                type="checkbox"
                className="me-2 mr-2"
                readOnly
                checked={subCatValue.includes(label)}
              />
              {label}
            </Dropdown.Item>
          );
        }) : []}
      </Dropdown.Menu>
    </Dropdown>
  );
}

SubCategoryCard.propTypes = {
  t: PropTypes.func.isRequired,
  subCatValue: PropTypes.array.isRequired,
  subCatData: PropTypes.array,
  onCardChange: PropTypes.func.isRequired,
};

const TranslateSubCategoryCard = translate(SubCategoryCard);
export default TranslateSubCategoryCard;
